/*
 * Confirmarile scurte ("Added to cart", "Task cancelled").
 *
 * Regula pe care o respecta: aici intra numai ce s-a REUSIT, plus erorile care
 * n-au un loc pe ecran. O eroare care apartine unui formular se afiseaza langa
 * formular, nu intr-un dreptunghi care dispare in cinci secunde - altfel omul
 * apasa din nou si nu afla niciodata ce a gresit.
 */

import { useCallback, useMemo, useRef, useState } from 'react';
import type { ReactNode } from 'react';
import { ToastContext, type ToastKind } from './ToastContext';

interface Toast {
  id: number;
  message: string;
  kind: ToastKind;
}

const VISIBLE_MS = 5000;

export function ToastProvider({ children }: { children: ReactNode }) {
  const [toasts, setToasts] = useState<Toast[]>([]);
  const nextId = useRef(1);

  const push = useCallback((message: string, kind: ToastKind = 'info') => {
    const id = nextId.current++;
    setToasts((current) => [...current, { id, message, kind }]);
    window.setTimeout(() => {
      setToasts((current) => current.filter((toast) => toast.id !== id));
    }, VISIBLE_MS);
  }, []);

  const api = useMemo(() => ({ push }), [push]);

  return (
    <ToastContext value={api}>
      {children}
      {/*
        aria-live="polite" si nu "assertive": mesajele astea confirma o actiune
        pe care omul tocmai a facut-o, deci pot astepta o pauza in citire. Un
        "assertive" ar taia vorba cititorului de ecran la fiecare adaugare in cos.
      */}
      <div className="toast-region" role="status" aria-live="polite">
        {toasts.map((toast) => (
          <div key={toast.id} className={`toast toast--${toast.kind}`}>
            {toast.message}
          </div>
        ))}
      </div>
    </ToastContext>
  );
}
